import type { Study } from '@pocketprep/types'
import { examMetadataModule } from '@/store/examMetadata/module'
import { runCloudFunction } from '@/store/parseUtils'

const fetchReadinessReportDetails = async () => {
    await examMetadataModule.actions.fetchExamMetadata()
    const currentExam = examMetadataModule.getters.getCurrentExamMetadata()

    if (!currentExam) {
        return
    }

    return await runCloudFunction<Study.Cloud.fetchReadinessReportDetails>(
        'fetchReadinessReportDetails',
        {
            examMetadataId: currentExam.objectId,
        }
    )
}

export default {
    fetchReadinessReportDetails,
}
